import MComponent from '../Toolkit/Components/Component';
import EnumProvider from './Enums';
import React from 'react';
import { MsalContext} from '@azure/msal-react';

type Props = {
    children: React.ReactNode;
};

/** */
type State = {};

class EnumClass extends MComponent<Props, State> {
    static contextType = MsalContext;
    context!: React.ContextType<typeof MsalContext>

    public render() {
        return(
            <EnumProvider msalContext={this.context}>
                {this.props.children}
            </EnumProvider>
        );
    }
}

export default EnumClass;